// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"ee6eebf7","29":"0cf02857","879":"446d4c5c","996":"6a78bc87"}[chunkId] + ".css";
};